import script from "./ItineraryFieldsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItineraryFieldsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ItineraryFieldsComponent.vue?vue&type=style&index=0&id=7598c4ec&lang=css"

const __exports__ = script;

export default __exports__